export default "__VITE_ASSET__BsHZn$7v__"